export default "__VITE_ASSET__D6I6X1cy__"